
import Loading from 'vux/src/components/loading/index.vue'

import { mapState } from "vuex";

export default {
name: "App",
components: {
Loading
},
computed: {
...mapState({
isShowLoading: state => state.isShow
})
},
mounted() {

if (this.iStorage.get("eventData") != null) {
let isHide =
this.iStorage.get("eventData").tenant_code == "lilly" &&
this.iStorage.get("eventData").typeDictTxt == "中型区域会"
? true
: false;
console.log(isHide);
this.iStorage.set("isHide", isHide);
switch (this.iStorage.get("eventData").tenant_code) {
case "lilly":
window.document.documentElement.setAttribute("data-theme", "lilly");
break;
case "roche":
window.document.documentElement.setAttribute("data-theme", "roche");
break;
case "novartis-master":
window.document.documentElement.setAttribute(
"data-theme",
"novartis"
);
break;
default:
window.document.documentElement.setAttribute("data-theme", "roche");
break;
}
}
}
};



// WEBPACK FOOTER //
// ./src/App.vue